'use client';
import { useState } from 'react';
import { useSearchParams } from 'next/navigation';
import { DialogTrigger } from '@radix-ui/react-dialog';
import Loader from '@/components/customercenter-ui/components/ui/loader';
import { useAccount } from '@/frontastic';
import { formatDateMoment } from '@/helpers/utils/siteUtils';
import { OrderTrackLogPayload } from '@/sdk/composable-commerce/types/payloads/AccountPayloads';
import { DATE_TIME_FORMAT } from '../../../../../constants/constant';
import { CUSTOMER_NOTES_ITEMS_PER_PAGE, PAYLOAD_QUERY } from '../../customer-detail/constants';
import { Table, TableColumnConfig } from '../../ui/customTable/Table';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../ui/dialog';
import Pagination from '../../utils/pagination';

const OrderTrackLogModal = ({ Texts }: any) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const params = useSearchParams();
  const { getOrderTrackLogs } = useAccount();
  const getOrderLogs = async (page?: number) => {
    setLoading(true);
    const payload = {
      orderId: params.get(PAYLOAD_QUERY.ORDER_ID),
      divisionCode: params.get(PAYLOAD_QUERY.DIVISION_CODE),
      pageNumber: page,
    } as OrderTrackLogPayload;
    await getOrderTrackLogs(payload).then((response) => {
      setLoading(false);
      if (response?.code === 'OK') {
        setTableData(response?.Logs);
        setTotalItems(response?.totalRecords ?? 0);
      }
    });
  };

  const tableHeaders: TableColumnConfig<any>[] = [
    {
      key: Texts.updatedOn,
      header: Texts.DATE_TIME,
      render: (data) => {
        const formatted = formatDateMoment(data, DATE_TIME_FORMAT);
        const [date, time, meridiem] = formatted.split(' ');
        return (
          <div>
            {date}
            <br />
            {time} {meridiem}
          </div>
        );
      },
    },
    { key: Texts.program, header: Texts.PROGRAM },
    { key: Texts.updatedBy, header: Texts.MODIFIED_BY, render: (data) => <div className="gbmask">{data}</div> },
    { key: Texts.event, header: Texts.EVENT },
    { key: Texts.oldStatus, header: Texts.OLD },
    { key: Texts.newStatus, header: Texts.NEW },
  ];

  const onPageChange = async (page: number) => {
    setCurrentPage(page);
    await getOrderLogs(page);
  };
  return (
    <Dialog
      open={open}
      onOpenChange={(value) => {
        if (value) {
          getOrderLogs();
        }
        setOpen(value);
      }}
    >
      <DialogTrigger className="rounded-md border-[1px] border-foggyGray px-3 py-1.5 text-xs font-medium">
        {Texts.trackLog}
      </DialogTrigger>
      <DialogContent className="custom-scrollbar max-h-[90%] max-w-[800px] overflow-y-auto bg-white sm:rounded-md">
        {loading && <Loader />}
        <DialogHeader>
          {/* chng-text-25px */}
          <DialogTitle className="text-2xl font-bold">
            <div className="text-2xl font-bold">{Texts.orderTrackLog}</div>
          </DialogTitle>
        </DialogHeader>
        <Table columns={tableHeaders} data={tableData} alignTextTop={true} />
        {!loading && tableData?.length === 0 ? <div>{Texts.noLogsFound}</div> : <></>}
        <section className="flex justify-end">
          <Pagination
            currentPage={currentPage}
            itemsPerPage={CUSTOMER_NOTES_ITEMS_PER_PAGE}
            totalItems={totalItems}
            onPageChange={onPageChange}
          ></Pagination>
        </section>
      </DialogContent>
    </Dialog>
  );
};

export default OrderTrackLogModal;
